// The cowboy's own record, kept in this browser (per player, like Godot's Profile): lifetime
// stats and achievements. Achievements are cosmetic for now. GAMEPLAY_LOOP §6.2 says unlocks
// will hang off them, never off a currency (§3), so anything that gates gear should read here.

export interface AchievementDef { id: string; name: string; desc: string }

/** Names follow GAMEPLAY_LOOP §6.2: odd and funny, folklore rather than checkboxes. */
export const ACHIEVEMENTS: AchievementDef[] = [
  { id: 'first_det', name: 'Accelerated Depreciation', desc: 'Detonate your first primed unit.' },
  { id: 'team_det', name: 'Shared Custody', desc: 'Detonate a unit a teammate primed.' },
  { id: 'assist5', name: 'Middle Management', desc: 'Prime five units that teammates finish off.' },
  { id: 'chain5', name: 'Chain of Custody', desc: 'Chain five detonations without dropping it.' },
  { id: 'multi5', name: 'Everything Must Go', desc: 'Scrap five units inside a second and a half.' },
  { id: 'pyrrhic', name: 'Pyrrhic Cowboy', desc: 'Detonate the last unit standing while the rest of your posse is down.' },
  { id: 'metal', name: 'Scrap Value', desc: 'Finish off a Metal Brute.' },
  { id: 'heat', name: 'Beat the Heat', desc: 'Clear a whole wave without dropping under 80% heat.' },
  { id: 'revive10', name: 'Next of Kin', desc: 'Revive ten teammates. Lifetime.' },
  { id: 'eom', name: 'Employee of the Month', desc: 'Top the Paperwork at the end of a posse run.' },
  { id: 'ping', name: 'Hand Signals', desc: 'Point something out to the posse.' },
  { id: 'ff_down', name: 'Acceptable Losses', desc: 'Down a teammate. It happens.' },
  { id: 'self_harm', name: 'Cooked Books', desc: 'Hurt yourself with your own ordnance.' },
  { id: 'crate', name: 'Capital Expenditure', desc: 'Requisition a crate weapon.' },
  { id: 'nemesis', name: 'Product Recall', desc: 'Scrap a posted outlaw.' },
];

export interface Profile {
  v: 1;
  runs: number;
  kills: number;
  detonations: number;
  teamDets: number;
  assists: number;
  revives: number;
  downs: number;
  bestWave: number;
  bestChain: number;
  /** achievement id → unix ms it was filed */
  ach: Record<string, number>;
  /** one-time teach beats already shown (client/review/coach.ts) */
  taught: Record<string, 1>;
}

const KEY = 'emg.profile';

function blank(): Profile {
  return { v: 1, runs: 0, kills: 0, detonations: 0, teamDets: 0, assists: 0, revives: 0, downs: 0, bestWave: 0, bestChain: 0, ach: {}, taught: {} };
}

export function loadProfile(): Profile {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return blank();
    const p = { ...blank(), ...JSON.parse(raw) } as Profile;
    p.ach ??= {}; p.taught ??= {};
    return p;
  } catch { return blank(); }
}

export function saveProfile(p: Profile) {
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch { /* private mode: lives for this session only */ }
}

/** File an achievement once. Returns its def the first time, null after. */
export function grant(p: Profile, id: string): AchievementDef | null {
  if (p.ach[id]) return null;
  const def = ACHIEVEMENTS.find((a) => a.id === id);
  if (!def) return null;
  p.ach[id] = Date.now();
  saveProfile(p);
  return def;
}
